import { useMemo } from 'react';
import { getSpecialPermissions } from '../services/getSpecialPermissions';

/**
 *
 * @returns {Object}
 *
 * @example
 * const { canOmitMandatoryVisibility, canAssignUsers, canSign } = useSpecialPermissions();
 *
 * if (canOmitMandatoryVisibility) {
 *   // Omitir modal de asignación
 * }
 */
export const useSpecialPermissions = () => {
  const permissions = useMemo(() => {
    return getSpecialPermissions();
  }, []);

  return {
    canOmitMandatoryVisibility: permissions.omit_mandatory_visibility || false,
    canAssignUsers: permissions.assign_users || false,

    canSign: permissions.sign || false,
    canUploadDocumentsWithoutSignature: permissions.documents_without_sing || false,

    canDownloadExpedient: permissions.download_expedient || false,
    canDownloadQR: permissions.download_qr || false,

    canUseAgreementTemplate: permissions.agreement_template || false,
    canUseAgreementTemplateIA: permissions.agreement_template_ia || false,
    canUseNotificationsTemplate: permissions.notifications_template || false,
    canUsePromotionsTemplate: permissions.promotions_template || false,
    canUseJudgmentsTemplate: permissions.judgments_template || false,
    canUseEmailsTemplate: permissions.emails_template || false,
    canUseWritTemplate: permissions.writ_template || false,

    canUseExpedientIndicators: permissions.expedient_indicators || false,
    canUseEditParties: permissions.create_edit_parts || false,

    allPermissions: permissions,
  };
};
